import axios from 'axios';

const backendUri = 'https://db.neophyte.live/fm-api/';

export const LoginAPI = async (user, password) => {
  try {
    const data = {
      username: user,
      hashed_password: password
    };
    const res = await axios.post(`${backendUri}users/login`, data, {
      headers: {
        Accept: 'application/json'
      }
    });
    console.log('response login', res);
    return res;
  } catch (error) {
    console.log('Error calling login api', error);
  }
};

export const checkId = async (userId) => {
  try {
    const response = await axios.get(`${backendUri}users/check/${userId}`, {
      headers: {
        Accept: 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error checking user ID:', error);
    return null;
  }
};

export const allStoresId = async () => {
  try {
    const response = await axios.get(`${backendUri}stores/all`, {
      headers: {
        Accept: 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error fetching store IDs:', error);
    return [];
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${backendUri}users/create`, userData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error creating user:', error);
    throw error;
  }
};

export const getOneUser = async (userId) => {
  try {
    const response = await axios.get(`${backendUri}users/${userId}`, {
      headers: {
        Accept: 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error fetching user:', error);
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await axios.put(`${backendUri}users/${userId}`, userData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log('Error updating user:', error);
    throw error;
  }
};


export const getTruckTurnaroundTime = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_truck_presence`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting truck turnaround time:', error);
    throw error;
  }
};

export const getMHEProductivity = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/mhe_availability`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting MHE productivity:', error);
    throw error;
  }
};

export const getDeskAvailability = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_availability_desk`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting desk availability:', error);
    throw error;
  }
};

export const getBreakRoomDwellTime = async (data, signal) => {
  try {
    const response = await axios.post(`${backendUri}kpis/avg_dwell_time_count`, data, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error getting break room dwell time:', error);
    throw error;
  }
};

export const getLineChartData = async (startDate, endDate, label) => {
  try {
    const response = await axios.post(`${backendUri}kpis/line_chart_track_id`, {
      startDate,
      endDate,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const unsafeMheCounts = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    console.log(date);
    const response = await axios.post(`${backendUri}v2/unsafe_mhe_counts`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const peopleKpiCounts = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/people_kpi_counts`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const ppeKitSafetyVest = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/ppe_kit_safety_vest`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const ppeKitHelmet = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/ppe_kit_safety_vest`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};
export const dockUtilization = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/dock_utilization`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const truckIdleTime = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/truck_idle_time`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const vehicleUnloaded = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/vehicle_unloaded`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const idleManPower = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/idle_man_power`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const truckInfo = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/truck_info`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching line chart data:', error);
    throw error;
  }
};

export const futureMetrics = async (startDate, endDate, label) => {
  try {
    const date = startDate.date;
    const response = await axios.post(`${backendUri}v2/idle_man_count`, {
      startDate,
      endDate,
      date,
      label
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching future metrics data:', error);
    throw error;
  }
};




export const createCamera = async (data, signal) => {
  try {
    console.log('Creating camera with data:', data);
    const response = await axios.post(`${backendUri}camera/create`, data, {
      signal,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('Create response:', response);

    // Ensure we return the correct structure
    if (response.data && response.data.base64Image) {
      return {
        base64Image: response.data.base64Image,
        camera_id: response.data._id,
        status: response.status
      };
    } else if (response.data && response.data._id) {
      return {
        camera_id: response.data._id,
        status: response.status,
        message: 'Camera created but no image available'
      };
    } else {
      console.error('Unexpected response format:', response.data);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Create camera error:', error.response || error);
    if (error.name === 'AbortError') {
      throw error;
    }
    if (error.response) {
      const errorMessage = error.response.data.message || error.response.data.error || error.response.statusText || 'Server error occurred';
      throw new Error(errorMessage);
    }
    throw new Error(error.message || 'Unknown error occurred');
  }
};

export const createZones = async (data) => {
  try {
    console.log('Creating zones with data:', data);
    const response = await axios.post(`${backendUri}zone/create`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('Create zones response:', response);

    // Ensure we return the correct structure
    if (response.data) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Create zones error:', error.response || error);
    if (error.response) {
      const errorMessage = error.response.data.message || error.response.data.error || error.response.statusText || 'Server error occurred';
      throw new Error(errorMessage);
    }
    throw new Error(error.message || 'Unknown error occurred');
  }
};

export const getCameras = async () => {
  try {
    console.log('Fetching cameras...');
    const response = await axios.get(`https://db.neophyte.live/fm-api/camera/getAll`);
    console.log('Get cameras response:', response);

    // Ensure we return the correct structure
    if (response.data && Array.isArray(response.data)) {
      return { cameras: response.data };
    } else if (response.data && Array.isArray(response.data.cameras)) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response.data);
      return { cameras: [] };
    }
  } catch (error) {
    console.error('Error fetching cameras:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error fetching cameras');
  }
};

export const getAllCameras = async () => {
  try {
    console.log('Fetching all cameras...');
    const response = await axios.get(`https://db.neophyte.live/fm-api/camera/getAll`);
    console.log('Get all cameras response:', response);

    // Ensure we return the correct structure
    if (response.data && Array.isArray(response.data)) {
      return { cameras: response.data };
    } else if (response.data && Array.isArray(response.data.cameras)) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response.data);
      return { cameras: [] };
    }
  } catch (error) {
    console.error('Error fetching all cameras:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error fetching all cameras');
  }
};

export const deleteCamera = async (cameraId) => {
  try {
    console.log('Deleting camera with ID:', cameraId);
    const response = await axios.delete(`${backendUri}camera/delete/${cameraId}`);
    console.log('Delete response:', response);

    // Ensure we return the correct structure
    if (response.data) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Delete camera error:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error deleting camera');
  }
};
